type Params = {
  email: string;
  password: string;
  username: string;
  roles: [];
};

export default function httpCreateUser(params: Params) {
  return fetch('/iam/createUser', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      return response.json().then((errorData) => {
        const error: any = new Error(errorData.detail || 'User creation failed');
        error.response = { data: errorData };
        error.status = response.status;
        throw error;
      });
    }
  });
}
